import React from 'react';
import { 
  Box, 
  FormControl, 
  InputLabel, 
  Select, 
  MenuItem,
  useTheme
} from '@mui/material';
import { styled } from '@mui/material/styles';

const FilterContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  marginBottom: theme.spacing(3),
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
  }
}));

const StyledFormControl = styled(FormControl)(({ theme }) => ({
  minWidth: 200,
  '& .MuiOutlinedInput-root': {
    backgroundColor: theme.palette.background.paper,
  }
}));

const locations = [
  { id: 'PAN', name: 'Panorama M&M GOLD', hours: '11:00-20:00' },
  { id: 'VVS', name: 'Panorama VVS', hours: '11:00-20:00' },
  { id: 'MODO', name: 'Modo M&M GOLD', hours: '10:00-21:00' },
  { id: 'KLIF', name: 'Klif M&M GOLD', hours: '09:00-21:00' },
  { id: 'GP', name: 'Galeria Północna M&M GOLD', hours: '10:00-22:00' },
  { id: 'SB', name: 'Stary Browar M&M GOLD', hours: '09:00-21:00' },
  { id: 'MB', name: 'Marbella', hours: null }
];

const ScheduleFilters = ({
  selectedLocation,
  setSelectedLocation,
  selectedEmployee,
  setSelectedEmployee,
  employees,
  isAdmin
}) => {
  const theme = useTheme();

  if (!isAdmin) return null;

  return (
    <FilterContainer>
      <StyledFormControl>
        <InputLabel id="location-select-label">Lokalizacja</InputLabel>
        <Select
          labelId="location-select-label"
          id="location-select"
          value={selectedLocation || ''}
          label="Lokalizacja"
          onChange={(e) => setSelectedLocation(e.target.value)}
        >
          <MenuItem value="">
            <em>Wszystkie</em>
          </MenuItem>
          {locations.map((location) => (
            <MenuItem 
              key={location.id} 
              value={location.id}
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                gap: 2
              }}
            >
              <span>{location.name}</span>
              {location.hours && (
                <span style={{ color: theme.palette.text.secondary, fontSize: '0.8em' }}>
                  {location.hours}
                </span>
              )}
            </MenuItem>
          ))}
        </Select>
      </StyledFormControl>

      <StyledFormControl>
        <InputLabel id="employee-select-label">Pracownik</InputLabel>
        <Select
          labelId="employee-select-label"
          id="employee-select"
          value={selectedEmployee || ''}
          label="Pracownik"
          onChange={(e) => setSelectedEmployee(e.target.value)}
        >
          <MenuItem value="">
            <em>Wszyscy</em>
          </MenuItem>
          {employees?.map((employee) => (
            <MenuItem key={employee.id} value={employee.id}>
              {employee.name}
            </MenuItem>
          ))}
        </Select>
      </StyledFormControl>
    </FilterContainer>
  );
};

export default ScheduleFilters;
